import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

// VA Run Board data. The server computes everything from live DB state, so
// polling IS the realtime mechanism: CM confirmations, invoice status flips,
// and retry waves all appear on the next refetch.
export const useVaRunReport = (month, opts = {}) =>
  useQuery(
    ['va-run-report', month],
    async () => {
      const res = await axios.get('/retell-admin/run-report', {
        params: month ? { month } : {},
      });
      return res.data;
    },
    {
      refetchOnWindowFocus: true,
      refetchInterval: 45000,
      staleTime: 30000,
      keepPreviousData: true,
      ...opts,
    },
  );
